package tech.gensert.portal.web.pages

import web.cssom.ident

object Area {
    val Header = ident("header")
    val Sidebar = ident("sidebar")
    val Content = ident("content")
    val Footer = ident("footer")
}
